export default {
    savings: {
        name: 'Amount to Savings',
        category:'Saving & Debt',
        type:'future'
    },
    mortgage_and_rent: {
        name: 'Rent or Mortgage Payment',
        category:'Rent or Mortgage Payment',
        type:'wants'
    },
    vehicle_purchase_and_lease: {
        name: "Vehicle Payment",
        category:'Car Payment',
        type:'wants'
    },
    other_debt_payments: {
        name: "Other Debt Payments",
        category:'Saving & Debt',
        type:'wants'
    },
    life_and_personal_insurance: {
        name: "Life & Personal Insurance",
        category:'Life & Other Personal Insurance',
        type:'wants'
    },
    cash_contributions: {
        name: "Charitable Giving",
        category:'Charitable Giving',
        type:'saving'
    },
    cash_contributions_gift: {
        name: "Gifts to Family & Friends",
        category:'Gifts to Family & Friends',
        type:'saving'
    },
    miscellaneous: {
        name: "Miscellaneous",
        category:'Miscellaneous',
        type:'wants'
    },
    tobacco_and_smoking: {
        name: "Smoking & Vaping",
        category:'Miscellaneous',
        type:'wants'
    },
    education: {
        name: "Education",
        category:'Education',
        type:'needs'
    },
    reading: {
        name: "Books & Subscriptions",
        category:'Miscellaneous',
        type:'wants'
    },
    personal_care: {
        name: "Personal Care",
        category:'Personal Care Products and Services',
        type:'needs'
    },
    toys_and_hobbies: {
        name: "Hobbies & Recreation",
        category:'Fun & Hobbies',
        type:'needs'
    },
    pets: {
        name: "Pets or Children",
        category:"Pets or Children",
        type:'needs'
    },
    media_hardware_and_services: {
        name: "TV/Audio Equipment & Streaming",
        category:'Cable / Internet / Home Entertainment',
        type:'wants'
    },
    fees_and_admissions: {
        name: "Events & Entertainment",
        category:'Fun & Hobbies',
        type:'wants'
    },
    medical_supplies: {
        name: "Medical Supplies",
        category:'Medical Spending',
        type:'needs'
    },
    prescription_drugs: {
        name: "Prescriptions",
        category:'Medical Spending',
        type:'needs'
    },
    medical_services: {
        name: "Medical Services",
        category:'Medical Spending',
        type:'needs'
    },
    health_insurance: {
        name: "Health Insurance",
        category:'Health Insurance',
        type:'wants'
    },
    public_and_other_transportation: {
        name: "Public Transportation",
        category:'Transportation Fares',
        type:'needs'
    },
    vehicle_insurance: {
        name: "Vehicle Insurance",
        category:'Car Insurance',
        type:'wants'
    },
    vehicle_maintenance_and_repairs: {
        name: "Vehicle Maintenance",
        category:'Car Maintenance',
        type:'wants'
    },
    gasoline: {
        name: "Gasoline & EV-Charging",
        category:'Gasoline & EV-Charging',
        type:'needs'
    },
    clothing_items_and_services: {
        name: "Clothing & Jewelry",
        category:'Clothing & Jewelry',
        type:'needs'
    },
    furniture_and_appliances: {
        name: "Furniture & Appliances",
        category:'Home Maintenance, Appliances, & Furniture',
        type:'needs'
    },
    housekeeping_supplies: {
        name: "Household Supplies",
        category:'Vacations & Trips',
        type:'needs'
    },
    other_household_expenses: {
        name: "Household Services",
        category:'Vacations & Trips',
        type:'needs'
    },
    water_and_public_services: {
        name: "Water & Sewer Bill",
        category:'Utilities - Other',
        type:'wants'
    },
    telephone_services: {
        name: "Cell Phone Bill",
        category:'Phone Services',
        type:'wants'
    },
    personal_services: {
        name: "Personal Services",
        category:'Miscellaneous"',
        type:'needs'
    },
    heating_fuels_other: {
        name: "Heating Oil & Propane",
        category:'Utilities - Other',
        type:'wants'
    },
    electricity: {
        name: "Power Bill",
        category:'Utilities - Power Bill',
        type:'wants'
    },
    natural_gas: {
        name: "Natural Gas Bill",
        category:'Utilities - Other',
        type:'wants'
    },
    other_lodging: {
        name: "Travel Accommodations",
        category:'Fun & Hobbies',
        type:'needs'
    },
    home_maintenance_and_repairs: {
        name: "Vacations & Trips",
        category:'Vacations & Trips',
        type:'needs'
    },
    alcoholic_beverages: {
        name: "Alcohol & Bars",
        category:'Groceries',
        type:'needs'
    },
    food_out: {
        name: "Dining Out",
        category:'Dining Out',
        type:'needs'
    },
    food_home: {
        name: "Groceries",
        category:'Groceries',
        type:'needs'
    },
  }
  